import React, { useState, useContext } from "react";
import { createContext } from "react";
import { useCuestionario } from "../hooks/useCuestionario"
import { useTranslation } from "react-i18next";
import { GeneralContext } from "../context/GeneralContext"

export const EjesContext = createContext();

export function EjesContextProvider(props) {

    const { t } = useTranslation()
    const { user, chartImage } = useContext(GeneralContext);
    const {  getCuestionarioReportEje, getCuestionarioReportParcial } = useCuestionario()
    const [openFinalizarCuestionario, setOpenFinalizarCuestionario] = useState(false);
    const handleOpenFinalizarCuestionario = () => setOpenFinalizarCuestionario(true);
    const [loading, setLoading] = React.useState(null);


    function GetCuestionarioReportEje(idCuestionario, Eje) {
        var reportPromise = getCuestionarioReportEje(user, idCuestionario, Eje.id_eje);
        reportPromise.then(
            (x) => {
                let blob = new Blob([x], { type: "application/pdf" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = t("Report.nombreInformeEje") + Eje.texto + ".pdf";
                link.click();
                setLoading(null)
            },
            (y) => {
                console.error("Error: " + y);
            }
        );
    }
    function GetCuestionarioReportParcial(idCuestionario) {
        var reportPromise = getCuestionarioReportParcial(user, idCuestionario, chartImage);
        reportPromise.then(
            (x) => {
                let blob = new Blob([x], { type: "application/pdf" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = t("Report.nombreInformeParcial");
                link.click();
                setLoading(null)
            },
            (y) => {
                console.error("Error: " + y);
            }
        );
    }


    return (
        <EjesContext.Provider value={{
            handleOpenFinalizarCuestionario,
            openFinalizarCuestionario,
            setOpenFinalizarCuestionario,
            t,
            GetCuestionarioReportEje,
            loading,
            setLoading,
            GetCuestionarioReportParcial,
        }}
        >
            {props.children}
        </EjesContext.Provider>
    )
}
